module.exports = __webpack_public_path__ + "static/media/baseMeme4.db31026a.jpg";